import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import WEB_CSS_CLASSNAMES from 'trade-in-360/constants/webCssClassnames.js';
import './StepsHeader.scss';

const StepsHeader = ({ currentStepIndex, useCBB }) => {
    const cssIsStepEnabled = (stepIndex) => {
        if (currentStepIndex >= stepIndex) return 'step-enabled';
        return null;
    };

    return (
        <div className="steps-wrapper flex-container">
            <div className={`step-wrapper step-enabled ${WEB_CSS_CLASSNAMES.BODY1}`}>
                <div>{LocaleService.t('TRADE_IN.SECTIONS.VEHICLE_INFO')}</div>
                <div className="underline"> </div>
            </div>
            <div className={`step-wrapper ${cssIsStepEnabled(1)} ${WEB_CSS_CLASSNAMES.BODY1}`}>
                <div>{LocaleService.t('TRADE_IN.SECTIONS.CONTACT_INFO')}</div>
                <div className="underline"> </div>
            </div>
            <div className={`step-wrapper ${cssIsStepEnabled(2)} ${WEB_CSS_CLASSNAMES.BODY1}`}>
                <div>{LocaleService.t(`TRADE_IN.SECTIONS.${useCBB ? 'ESTIMATED_VALUE' : 'OFFICIAL_EVALUATION'}`)}</div>
                <div className="underline"> </div>
            </div>
        </div>
    );
};

StepsHeader.defaultProps = {
    currentStepIndex: 0,
    useCBB: false,
};

StepsHeader.propTypes = {
    currentStepIndex: PropTypes.number,
    useCBB: PropTypes.bool,
};

StepsHeader.displayName = 'StepsHeader';

export default StepsHeader;
